import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ImprivataIdPush.scss';
import Logout from '../../../shared/Logout/Logout';
import crossIcon from '../Icons/cross.svg';
import helpIcon from '../Icons/help.svg';
import imprivataIcon from '../Icons/imprivata.svg';
import Popover from '../../../shared/Popover/Popover.js';
import Header from '../../../shared/Header/Header';

/**
 * Imprivata ID (PUSH) prompt
 * @class ImprivataIdPush
 * @extends {Component}
 */
class ImprivataIdPush extends Component {
  static propTypes = {
    /** Header image */
    headerImage: PropTypes.string,
    /** Header title */
    headerTitle: PropTypes.string,
    /** Header description */
    deviceDescription: PropTypes.object,
    /** Link to enroll page*/
    enrollDeviceLink: PropTypes.func,
    /** Link to the manage devices page*/
    manageDeviceLink: PropTypes.func,
    /** useTokenText string*/
    useTokenText: PropTypes.string,
    /** start Manual IID Token input */
    startManualIIDToken: PropTypes.func,
    /** link to display more options */
    moreOptionsLink: PropTypes.object,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** Text to be included in the information overlay*/
    infoPopout: PropTypes.string,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
    /** Function executed when retry link is clicked. */
    onRetryClick: PropTypes.func,
    /** Text displayed on the retry link. Entering an __empty string__ will
     __hide__ the link. */
    retryText: PropTypes.string,
    /** Matching number. */
    matchingNumber: PropTypes.string,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };

  static defaultProps = {
    deviceDescription: <span>Approve on your smartphone</span>,
    headerTitle: 'Imprivata ID',
    logoutComponent: <Logout />,
    moreOptionsLink: null,
    useTokenText: 'or',
    // Parkland custom UX
    useCustomUX: false,
  };

  startManualToken = (event) => {
    event.preventDefault();
    this.props.startManualIIDToken(event);
  };

  retrySend = event => {
    event.preventDefault();
    this.props.onRetryClick(event);
  };

  render() {
    const {
      enrollDeviceLink,
      footer,
      deviceDescription,
      headerImage,
      headerTitle,
      infoPopout,
      logoutComponent,
      manageDeviceLink,
      moreOptionsLink,
      rememberText,
      startManualIIDToken,
      useTokenText,
      matchingNumber,
    } = this.props;

    const rb = require('react-bootstrap');

    return (
      <div className='CIDRA'>
        {logoutComponent}
        {this.props.useCustomUX ?
          (<Header />)
          :
          (
            <div className='Header-Box'>
              <img src={headerImage} className='Modality-Icon header-image' alt='lock' />
              <div className='Header-Text'>
                <span>{headerTitle}</span>
              </div>
            </div>
          )
        }
        {enrollDeviceLink && (
          <div>
            <div className='Enroll-New-Device'>
              {manageDeviceLink
                ? <span className='Manage-Devices-Text' onClick={manageDeviceLink}>Manage devices</span>
                : null
              }
              <span className='Enroll-New-Device-Text' onClick={enrollDeviceLink}>Enroll new device</span>
            </div>
            <div className='Enroll-New-Device-Circle btn' onClick={enrollDeviceLink} />
            <img className='Enroll-New-Device-Cross' src={crossIcon} onClick={enrollDeviceLink} alt='cross' />
          </div>
        )}

        {/* /part that shows the connected device/ */}
        <div className='device-name-description'>{deviceDescription}</div>

        {/* /part that shows the matching number/ */}
        {matchingNumber && (
          <div>
            <div className='matching-number'>{matchingNumber}</div>
            <div className='update-IID-app'>Update Imprivata ID app to use the code</div>
          </div>
        )}

        {(useTokenText && startManualIIDToken) && (
          <div className='start-manual-IID-token'>
            <div>
              {useTokenText}
              {' '}
              {
                // eslint-disable-next-line
              }<a
                href=''
                id='SingleInput_retry_link'
                onClick={this.startManualToken}
              >
                enter the Imprivata ID token code
              </a>
            </div>
          </div>
        )}
        {(this.props.retryText) && (
          <div className='IID-push-retry'>
            {this.props.retryText && (
              <div>
                {this.props.retryText}
                {' '}
                {
                  // eslint-disable-next-line
                }<a
                  href=''
                  id='IID_push_retry_link'
                  onClick={this.retrySend}
                >
                  Retry
                </a>
              </div>
            )}
          </div>
        )}
        {footer}
        <div>
          {(rememberText) && (
            <div className='text-center Remember-Text'>
              <input type='checkbox' name='rememberBox' value='remember' defaultChecked={false} />
              &emsp;
              {rememberText}
              <Popover
                body={<div className='popover-text'>{infoPopout}</div>}
                trigger={<rb.Button bsstyle='link'>
                  <img className='Help-Icon' src={helpIcon} alt='help' />
                </rb.Button>}
                triggerType={['hover', 'focus',]}
              />
            </div>
          )}
          {(moreOptionsLink) && (
            <div className='text-center More-Options btn-link'>
              {moreOptionsLink}
            </div>
          )}
          <hr className='Footer-hr' />
          <img className='Footer' src={imprivataIcon} alt='logo' />
        </div>
      </div>
    );
  }
}

export default ImprivataIdPush;
